import { Contact } from "./contact";
import { Organization } from "./organization";
import { SubscriptionInfo } from "./thing";

export class Partner {
    id: string;
    name: string;
    organization: Organization;
    values: any;
    code: string;
    country: string;
    timezone: string;
    properties: { [propertyName: string]: string | number | Contact[] };
    domainPrefix: string;
    domainType: PartnerDomainType;
    domain: string;
    parentPartnerId: string;
    sparePartsProvider: boolean;
    installationServiceProvider: boolean;
    pricingHiddenToCustomers: boolean;
    type: PartnerType;
    subscriptionInfo?: SubscriptionInfo;
    status: PartnerStatus;
    lastAccessTimestamp: number;
    creationTimestamp: number;
    serviceProvider: boolean;
}

export enum PartnerDomainType {
    DOMAIN_PREFIX = "DOMAIN_PREFIX",
    FULL_DOMAIN = "FULL_DOMAIN"
}

export enum PartnerType {
    DATA_RECIPIENT = 'DATA_RECIPIENT',
    CHANNEL = 'CHANNEL'
}

export enum PartnerStatus {
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED'
}